import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=09a83dfa&scoped=true"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"
import style0 from "./cards.vue?vue&type=style&index=0&id=09a83dfa&prod&scoped=true&lang=css"
import style1 from "./cards.vue?vue&type=style&index=1&id=09a83dfa&prod&lang=css"
import style2 from "./cards.vue?vue&type=style&index=2&id=09a83dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a83dfa",
  null
  
)

export default component.exports